module.exports = "https://web-assets.ifttt.com/packs/media/partners/test-red-851a02cf.svg";